
<template>
    <div class="login-container">
        <nav-bar :showBack="true" :title="this.$t('选择区号')" :isRoot="false"/>
         <van-search class="search-bar" v-model="value" :placeholder="this.$t('请输入国家/地区/区号')" />
         <div class="scrollable-content">
         <div v-for="(item, index) in regionList" :ref="item.B" :class="['item-container',mobileRegion === item.B ? 'item-container-select-color' :''] " :key="index" @click="clickItem(item)">
            <div :class="mobileRegion === item.B ? 'item-text-selected' : 'item-text'" > {{ item.N }}  </div>
            <div :class="mobileRegion === item.B ? 'item-text-region-selected' : 'item-text-region'" >  {{ item.C }} </div>
            <img v-show="mobileRegion === item.B" class="check-img" src="@/icons/list_check.png" />
         </div>
         </div>
    </div>

   </template>
<script>

import { mapGetters } from 'vuex'
import NavBar from '@/components/NavBar'
import PageBase from '@/mixin/page-base'

export default {
  mixins: [PageBase],
  components: {
    NavBar
  },

  mounted () {
    this.setViewportHeight()
    window.addEventListener('resize', this.setViewportHeight)

    this.initParamter()
    this.value = ''
    this.$nextTick(() => {
      this.$refs[this.mobileRegion][0].scrollIntoView()
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setViewportHeight)
  },

  computed: {
    ...mapGetters(['mobilePrefixList']),
    regionList() {
      if (this.value.length > 0) {
        return this.mobilePrefixList.filter(item => item.N.toLowerCase().includes(this.value.toLowerCase()) || item.C.toLowerCase().includes(this.value.toLowerCase()))
      } else {
        return this.mobilePrefixList
      }
    }
  },
  data() {
    return {
      value: ''
    }
  },
  watch: {

  },
  methods: {

    setViewportHeight() {
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
    },
    clickItem(item){
      this.$store.dispatch('user/setSelectMobileRegionCode', item.B)
      this.$router.back()
    },
    mobilePrefix(item){
      return item.N
    },
    regionName(item){
      return item.C
    }

  }
}
</script>
   <style lang="less" scoped>
  .login-container {
        background: #ffffff;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        position: relative;
        height: calc(var(--vh, 1vh) * 100);
        overflow-y: hidden;
        .title {
            font-size: 16px;
            font-weight: 500;
            color: #2C2C2C;
            height: 55px;
            line-height: 55px;
        }
        .search-bar{
            width: 100%;
            height: 50px;
        }
        .search-bar /deep/ .van-search__content {
            border-radius: 8px;
        }
        .search-bar /deep/ .van-field {
          align-items: center;
        }
        .search-bar /deep/ .van-field__control {
          font-size: 14px;
          height: 30px;
        }
        .scrollable-content{
            overflow-y: scroll;
            flex: 1;
            width: 100%;
        }
        .item-container {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            box-sizing: border-box;
            padding: 0px 24px;
            height: 64px;
            .item-text {
                font-size: 14px;
                font-weight: 500;
                color: #2C2C2C;
                width:80px;
            }
            .item-text-selected {
                font-size: 14px;
                font-weight: 500;
                color: #00BBBF;
                width:80px;
            }
            .item-text-region {
                font-size: 14px;
                font-weight: 500;
                color: #2C2C2C;
                flex: 1;
            }
            .item-text-region-selected {
                font-size: 14px;
                font-weight: 500;
                color: #00BBBF;
                flex: 1;
            }
            .check-img {
                width: 24px;
                height: 24px;
            }
        }
        .item-container-select-color {
            background-color: rgba(0, 187, 191, 0.1);
        }
   }
   </style>
